var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMobileSalesPage
    ? _c(
        "div",
        { staticClass: "px-1_5 bg-white" },
        [
          [_vm.cartRoute, _vm.checkoutRoute].includes(_vm.$route.name)
            ? _c("checkout-step", {
                attrs: {
                  "hidden-md": "hidden-md",
                  "cart-route": _vm.cartRoute,
                  "checkout-route": _vm.checkoutRoute,
                  "cart-id": _vm.cart.id
                }
              })
            : [
                _c("search", {
                  attrs: { value: _vm.search },
                  on: {
                    "search-input": function($event) {
                      return _vm.$emit("search-input", $event)
                    },
                    "perform-search": function($event) {
                      return _vm.$emit("perform-search", $event)
                    }
                  }
                }),
                !_vm.isWhitelabel
                  ? _c("links", {
                      attrs: { categories: _vm.categories },
                      on: {
                        "toggle-shop-menu": function($event) {
                          return _vm.$emit("toggle-shop-menu", $event)
                        }
                      }
                    })
                  : _vm._e()
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }